var $ = jQuery.noConflict();

$(window).on('load', function () {
    let method = 'front';
    if ($('body').hasClass('wp-admin'))
        method = 'wp-admin';

    var initializeBlock = function ($block) {

        $('.js-button-show-more').on('click', function (e){
            e.preventDefault();
            $(this).remove();
            $('.js-show-more-text').slideToggle(400);
        });

    };

    window.onload = function () {
        initializeBlock($(this));
    }();

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=title-text-3-columns-tiles', initializeBlock);
    }
});
